import { createCachedSelector } from 're-reselect';

import IconNames from '@/components/atomic/atoms/data-display/icons/symbol/enum';
import getIcons from '@/state/selectors/icons/get-icons';
import { IStore } from '@/state/slices/typings';

const iconExists = createCachedSelector(
	[getIcons, (_: IStore, icon: IconNames) => icon],
	(icons, icon) => icons.includes(icon),
)((_: IStore, icon: IconNames) => icon);

export default iconExists;
